<script>
  'use strict'

  import { PolarArea, mixins } from 'vue-chartjs'

  const { reactiveProp } = mixins

  export default {
    extends: PolarArea,

    mixins: [reactiveProp],

    props: ['chartData', 'options'],

    mounted () {
      this.renderChart(this.chartData, this.options)
    },

    watch: {
      options: {
        handler: function (newVal, oldVal) {
          this.renderChart(this.chartData, this.options)
        },
        deep: true
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/vue-chart/charts/polar-area.vue